<template>
  <div>
    <b-card
      id="full-ens-form"
    >
      <b-card-title>
        <div class="float-left">
          <h4>{{ title }}</h4>
        </div>
        <div class="float-right mb-1">
          <!--This span is required to show tooltip on disabled button. -->
          <span
            v-b-tooltip.hover.top.v-danger="getTooltipMsg"
          >
            <b-button
              id="submit-full-ens"
              variant="primary"
              :disabled="manifestHasIssues || requestPending || submittedEnsCount > 0"
              @click="sendEns('F26', 'pre-arrival')"
            >
              Submit ENS house-filings
              <b-spinner
                v-if="requestPending"
                small
              />
            </b-button>
          </span>
        </div>
        <b-form-checkbox
          id="show-ens-statuses"
          v-model="showAllENSStatuses"
          switch
          class="float-right mx-2"
        >Show all ENS statuses</b-form-checkbox>
      </b-card-title>
      <b-card-text>
        <b-row
          align-h="center"
          class="text-center"
        >
          <div class="text-center">
            <p v-if="submissionStatus && submittedEnsCount === 0">
              {{ submissionStatus }}
            </p>
          </div>
        </b-row>
      </b-card-text>
      <b-table
        :fields="fields"
        :items="ENSItems"
        thead-class="d-none"
      >
        <template #cell(name)="data">
          <router-link :to="data.item.link">
            <strong :class="data.item.class">{{ data.item.name }}</strong>
          </router-link>
        </template>

        <template #cell(count)="data">
          <router-link :to="data.item.link">
            <strong :class="data.item.class">{{ data.item.count }}</strong>
          </router-link>
        </template>

      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormCheckbox,
  BTable,
  BCardTitle, BSpinner, BRow, BCardText, BButton, VBTooltip,
} from 'bootstrap-vue'
import handleError from '@/views/components/errorHandler'
import { EventBus } from '@core/utils/utils'

export default {
  components: {
    BCardText,
    BRow,
    BSpinner,
    BCardTitle,
    BFormCheckbox,
    BCard,
    BTable,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    shipment: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      requestPending: false,
      showAllENSStatuses: false,
      declarations: this.shipment.ens_declarations || [],
      title: 'ENS submission process',
      submissionStatus: 'ENS submission not started',
      showMarkDoneConfirm: false,
      fields: [
        'name',
        {
          key: 'count',
          tdClass: 'text-right',
        },
      ],
    }
  },
  computed: {
    manifestHasIssues() {
      const { statistics } = this.$attrs
      return statistics?.prohibited?.h7 > 0 || statistics?.reducedVat?.h7 > 0 || statistics?.missingHsCodes?.h7 > 0
    },
    ENSItems() {
      const { statistics } = this.$attrs
      let statsRows = [
        {
          name: 'Preparing to send',
          link: `/shipments/${this.shipment.id}/declarations/preparing-to-send-ens`,
          class: 'text-secondary',
          count: statistics?.preparingToSend?.ens ?? 0,
        },
        {
          name: 'Waiting for customs',
          link: `/shipments/${this.shipment.id}/declarations/waiting-customs-ens`,
          class: 'text-secondary',
          count: statistics?.waitingForCustoms?.ens ?? 0,
        },
        {
          name: 'Needs attention',
          link: `/shipments/${this.shipment.id}/declarations/needs-attention-ens`,
          class: 'text-warning',
          count: statistics?.needsAttention?.ens ?? 0,
        },
        {
          name: 'Registered',
          link: `/shipments/${this.shipment.id}/declarations/registered-ens`,
          class: 'text-success',
          count: statistics?.registered?.ens ?? 0,
        },
        {
          name: 'Special case',
          link: `/shipments/${this.shipment.id}/declarations/special-case-ens`,
          class: 'text-warning',
          count: statistics?.specialCase?.ens ?? 0,
        },
      ]
      if (!this.showAllENSStatuses) {
        statsRows = statsRows.filter(x => x.count > 0)
      }
      return statsRows
    },
    submittedEnsCount() {
      return this.ENSItems.reduce((acc, item) => acc + item.count, 0)
    },
    getTooltipMsg() {
      if (this.manifestHasIssues) {
        return 'Fix parcel issues before submitting ENS filings'
      }
      return ''
    },
  },
  methods: {
    sendEns(messageType, requestType) {
      this.requestPending = true
      this.$http.post(`/v1/shipments/${this.shipment.id}/ensDeclarationsFull`, {
        messageType: messageType,
        declarationType: requestType,
      })
        .then(() => {
          EventBus.$emit('refresh-statistics')
          this.requestPending = false
        })
        .catch(error => {
          handleError(error, this.$toast)
          this.requestPending = false
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
